import type { MantineTheme } from '@mantine/core'

/** Shared field chrome — surface tokens (works on shade + paper + modals). */
export const stepcareFieldInputStyles = {
  input: {
    color: 'var(--sc-surface-fg)',
    '--mantine-color-text': 'var(--sc-surface-fg)',
    backgroundColor:
      'color-mix(in srgb, var(--sc-surface-fg) 4%, var(--sc-surface-bg))',
    borderColor: 'var(--sc-surface-border)'
  },
  section: {
    color: 'var(--sc-surface-fg)',
    '--mantine-color-text': 'var(--sc-surface-fg)',
    backgroundColor: 'transparent'
  },
  label: {
    color: 'color-mix(in srgb, var(--sc-surface-fg) 72%, transparent)'
  },
  description: {
    color: 'color-mix(in srgb, var(--sc-surface-fg) 52%, transparent)'
  }
} as const

export const stepcareSearchInputClassNames = {
  input: 'sc-input-search',
  section: 'sc-input-search-section'
} as const

export function stepcareTextInputStyles(_theme: MantineTheme) {
  return stepcareFieldInputStyles
}
